import {Component, inject} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {SitePublicService} from 'src/app/services/site-public.service';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';


@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styleUrls: [ './pages.component.scss' ]
})
export class PagesComponent {

  public html_page_temp: any;
  public html_page: SafeHtml;
  private sanitizer = inject(DomSanitizer);

  constructor (
    private _activeRoute: ActivatedRoute,
    private _sitePublicService: SitePublicService
  ) {
    this._activeRoute.params.subscribe(data => {
      const depto = data[ 'depto' ];
      const page = data[ 'page' ];
      console.log(depto + "/" + page)
      this.getPage(depto, page);
    })
  }

  getPage (depto, page) {
    this._sitePublicService.getPage(depto, page)
      .subscribe((result) => {
        this.html_page = result.html
       //const rawData = result.html
        //this.html_page = this.sanitizer.bypassSecurityTrustHtml(rawData);
      });
  }

  showPage () {
    this._sitePublicService.displayHtml(this.html_page)
  }


}
